export default "__VITE_ASSET__Cip8o6Tj__"